import {Action, Selector, State, StateContext} from "@ngxs/store";
import {InstrumentoStateInterface} from "../models/instrumento-state.interface";
import {Injectable} from "@angular/core";
import {RequestService} from "../services/request.service";
import {AppHelper} from "../helpers/app.helper";
import {ApiConfig} from "../config/api.config";
import {InstrumentoService} from "../services/instrumento.service";
import {InstrumentoAction} from "../actions/instrumento-action";
import FetchFavoritos = InstrumentoAction.FetchFavoritos;
import FetchFavorites = InstrumentoAction.FetchFavorites;
import FetchTiposInstrumento = InstrumentoAction.FetchTiposInstrumento;
import FetchSectores = InstrumentoAction.FetchSectores;
import {PriceUpdateService} from "../services/price-update.service";
import { async } from "rxjs/internal/scheduler/async";

@State<InstrumentoStateInterface>({
  name: 'instrumentoData',
  defaults: {
    favoritos: [],
    favorites: [],
    tiposInstrumento: [],
    sectores: []
  }
})
@Injectable()
export class InstrumentoState {

  constructor(private requestService: RequestService,
              private instrumentoService: InstrumentoService) {
  }

  @Selector()
  static favoritos(state: InstrumentoStateInterface) {

    return state.favoritos;
  }

  @Selector()
  static favorites(state: InstrumentoStateInterface) {

    return state.favorites;
  }

  @Selector()
  static tiposInstrumentos(state: InstrumentoStateInterface) {

    return state.tiposInstrumento;
  }

  @Selector()
  static sectores(state: InstrumentoStateInterface) {

    return state.sectores;
  }

  @Action(FetchFavoritos)
  async fetchFavoritos({getState, setState}: StateContext<InstrumentoStateInterface>, action: FetchFavoritos){

    let data: any[] =[];
    try {

      if (action.ids?.length) {

        let qArr: string[] = [];

        action.ids.forEach(id => {

          qArr.push(`id[]=${id}`);
        });

        data = await this.instrumentoService.obtenerIntrumentos({},
          'pageable=0&' + qArr.join('&'), true);
      }

    } catch (e) {

      AppHelper.DevPrint(e);
    }
    
    setState({ ...getState(), ... { favoritos: data } });
  }

  @Action(FetchFavorites)
  async fetchFavorites({getState, setState}: StateContext<InstrumentoStateInterface>, action: FetchFavorites){

    let data: any[] =[];
    try {

      if (action.ids?.length) {

        let qArr: string[] = [];

        action.ids.forEach(id => {

          qArr.push(`id[]=${id}`);
        });

        data = await this.instrumentoService.obtenerIntrumentos({},
          'pageable=0&' + qArr.join('&'), true);
      }

    } catch (e) {

      AppHelper.DevPrint(e);
    }

    setState({ ...getState(), ... { favorites: data } });
  }

  @Action(FetchTiposInstrumento)
  async fetchTiposInstrumento({getState, setState}: StateContext<InstrumentoStateInterface>){

    let data: any[] = [];
    try {

      data = await this.requestService.get('tipo_instrumento_index',
        { hideLoading: true, params: { } });

      data.forEach(tipo => {

        tipo.imagen = tipo.imagen ? `${ApiConfig.uploadUrl}/images/${tipo.imagen}`: null;
      });

    } catch (e) {

      AppHelper.DevPrint(e);
    }

    setState({ ...getState(), ... { tiposInstrumento: data } });
  }

  @Action(FetchSectores)
  async fetchSectores({getState, setState}: StateContext<InstrumentoStateInterface>){

    let data: any[] = [];
    try {

      const result = await this.requestService.get('sector_index',
        { hideLoading: true, params: { }, query: `&pagination=1000` });

      data = AppHelper.Tree(result, null)?.children;
    } catch (e) {

      AppHelper.DevPrint(e);
    }

    setState({ ...getState(), ... { sectores: data } });
  }

}
